import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import DialogActions from '@material-ui/core/DialogActions';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Chip from '@mui/material/Chip';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment';
import { connect } from 'react-redux';
import originFields from '../../defaults/PointOfOriginFields.json';
import fireCauseConfig from '../../defaults/fireCauseConfig.json'
import { getOriginValidationInfo } from '../../utils/incidentHelper'
import theme from '../../muiTheme';
import './SpliceDialog.css';
const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

const fuelModelFields = ["PredominantFuelModel", "PredominantFuelGroup"];
const fireCauseIdFields = ["FireCauseID", "FireCauseGeneralID", "FireCauseSpecificID", "FireCauseSpecificDetailID", "FireCauseAgeCategoryID", "FireCauseActivityGroupID", 'IsCauseProhibited'];
    
class SpliceDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spliceFields: [],
      attributesFromLosingFODR: [],
      savedSpliceRecord: {},
      canSaveSplice: false,
      primarySet: false,
      primaryFORID: null,
      isValid: false,
      validationMessages: [],
      firstValidationMessage: ''
    };
  }
  componentWillReceiveProps(nextProps)
  {
    if (nextProps.spliceModel && nextProps.spliceModel !== this.props.spliceModel)
    {
      this.setState(
        {
          savedSpliceRecord: nextProps.spliceModel.SavedSplicedRecord
        });
    }
  }

  setSpliceRecord = (spliceRecord) => {
    this.setState({
      savedSpliceRecord: spliceRecord,
      attributesFromLosingFODR: []
    });
  }

  canSaveSplice = (spliceRecord) => {
    let canSave = true;
    for (var i = 0; i < this.props.spliceModel.DifferentFields.length; i++) {
      if (!spliceRecord.hasOwnProperty(this.props.spliceModel.DifferentFields[i])) 
      {
        console.log("spliceRecord does not have " + this.props.spliceModel.DifferentFields[i]);
        canSave = false;
      }
    }

    return canSave;
  }

  getDataStyle = (fieldName, isChecked) => {
    return {
      textAlign: 'left',
      fontSize: '0.8em',
      padding: '8px',
      color: (this.state.primarySet && isChecked) ? 'black' : 'lightgray'
    };
  }

  getHeaderStyle = (forId) => {

    const isSet = this.state.primarySet;
    const isSetAndIsPrimary = (this.state.primarySet && this.state.primaryFORID === forId);

    return {
      textAlign: 'left',
      fontSize: '0.8em',
      padding: '8px',
      color: (!isSet || isSetAndIsPrimary) ? 'black' : 'lightgray'
    };
  }

  showChip = (forId) => {
    return (this.state.primaryFORID === forId) ?
      (<Chip variant="outlined" color="primary" size="small" label="Primary" />)
      : "";
  }
  makePrimary = (forId) => {
    const selectedSpliceRecord = (this.props.spliceModel.PrimaryFOR.FORID === forId) ? this.props.spliceModel.PrimaryFOR : this.props.spliceModel.SecondaryFOR;

    let x = this.state.savedSpliceRecord;
    for (var i = 0; i < this.props.spliceModel.DifferentFields.length; i++) 
    {
      x[this.props.spliceModel.DifferentFields[i]] = selectedSpliceRecord[this.props.spliceModel.DifferentFields[i]];
    }

    for (var m = 0; m < this.props.spliceModel.SameFields.length; m++) 
    {
      x[this.props.spliceModel.SameFields[m]] = selectedSpliceRecord[this.props.spliceModel.SameFields[m]];
    }
    this.setState({
      primarySet: true,
      savedSpliceRecord: x,
      primaryFORID: forId,
      canSaveSplice: true
    });
  }

  getLabelStyle = () => {

    return {
      textAlign: 'left',
      fontSize: '0.8em',
      padding: '8px',
      fontWeight: 'bold',
      color: (this.state.primarySet) ? 'black' : 'gray'
    };
  }

  onSpliceChange = (key, value, forId) => {
    const isFromLosingFodr = forId !== this.state.primaryFORID;
    
    let newSpliceRecord = this.state.savedSpliceRecord;
    let losingFodrAttrs = this.state.attributesFromLosingFODR;

    if (isFromLosingFodr && !this.state.attributesFromLosingFODR.includes(key)) 
    {
      losingFodrAttrs.push(key);
    };

    if (!isFromLosingFodr && this.state.attributesFromLosingFODR.includes(key)) 
    {
      losingFodrAttrs = losingFodrAttrs.filter(item => item !== key);
    }

     //This is a Fire Cause Field, they all need to move together.
    if (fireCauseIdFields.includes(key)) 
    {
      for (var i = 0; i < fireCauseIdFields.length; i++) 
      {
        if (isFromLosingFodr && !this.state.attributesFromLosingFODR.includes(fireCauseIdFields[i])) 
        {
          losingFodrAttrs.push(fireCauseIdFields[i]);
          newSpliceRecord[fireCauseIdFields[i]] = this.props.spliceModel.SecondaryFOR[fireCauseIdFields[i]];  
        };
    
        if (!isFromLosingFodr && this.state.attributesFromLosingFODR.includes(fireCauseIdFields[i])) 
        {
          const attrCauseValue = fireCauseIdFields[i];
          losingFodrAttrs = losingFodrAttrs.filter(item => item !== attrCauseValue);
          newSpliceRecord[fireCauseIdFields[i]] = this.props.spliceModel.PrimaryFOR[fireCauseIdFields[i]]; 
        }
      }
    }

     //This is a Fuel Model field, they all need to move together.
    if (fuelModelFields.includes(key)) 
    {
      for (var j = 0; j < fuelModelFields.length; j++) 
      {
        if (isFromLosingFodr && !this.state.attributesFromLosingFODR.includes(fuelModelFields[j])) 
        {
          losingFodrAttrs.push(fuelModelFields[j]);
          newSpliceRecord[fuelModelFields[j]] = this.props.spliceModel.SecondaryFOR[fuelModelFields[j]];  
        };
    
        if (!isFromLosingFodr && this.state.attributesFromLosingFODR.includes(fuelModelFields[j])) 
        {
          const attrValue = fuelModelFields[j];
          losingFodrAttrs = losingFodrAttrs.filter(item => item !== attrValue);
          newSpliceRecord[fuelModelFields[j]] = this.props.spliceModel.PrimaryFOR[fuelModelFields[j]]; 
        }
      }
    }

    newSpliceRecord[key] = value;

    let validationInfo = getOriginValidationInfo(newSpliceRecord, []);
    let errorMessage = '';
    for (const property in validationInfo.errors) 
    {
      errorMessage += property + ": " + validationInfo.errors[property];
    }

    this.setState(
      {
        savedSpliceRecord: newSpliceRecord,
        canSaveSplice: (this.canSaveSplice(newSpliceRecord) && validationInfo.isValid),
        attributesFromLosingFODR: losingFodrAttrs,
        validationMessages: validationInfo.errors,
        firstValidationMessage: (validationInfo.errors && validationInfo.errors.length > 0) ? errorMessage : ''
      });
    //console.log(newSpliceRecord);
  }

  getLabelName = (value) => 
  {
    switch (value) {
      case originFields.fireCauseId:
        return "Fire Cause";

      case originFields.fireCauseGeneralId:
        return "Fire Cause General";

      case originFields.fireCauseSpecificId:
        return "Fire Cause Specific";

      case originFields.fireCauseActivityGroupID:
        return "Fire Cause Activity Group";

      case originFields.fireCauseAgeCategoryID:
        return "Fire Cause Age Category";

      case originFields.fireCauseSpecificDetailID:
        return "Fire Cause Specific Detail"; 

        case originFields.isCauseProhibited:
          return "Fire Cause Prohibited"; 

      default:
        return value;
    }
  }

  getFireCauseDisplayValue = (value, fieldName) => {


    if (value === null || value === "") 
    {
      return "";
    }


    switch (fieldName) {
      case originFields.fireCauseId:
        return value !== null ? fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === value).FireCauseName : "";

      case originFields.fireCauseGeneralId:
        return value !== null ? fireCauseConfig.GeneralFireCauses.find(cause => cause.CauseGeneralID === value).CauseGeneral : "";

      case originFields.fireCauseSpecificId:
        return value !== null ? fireCauseConfig.SpecificFireCauses.find(cause => cause.CauseSpecificID === value).CauseSpecific : "";

      case originFields.fireCauseActivityGroupID:
        return value !== null ? fireCauseConfig.CauseActivityGroups.find(cause => cause.ActivityGroupID === value).ActivityGroup : "";

      case originFields.fireCauseAgeCategoryID:
        return value !== null ? fireCauseConfig.AgeCategories.find(cause => cause.AgeCategoryID === value).AgeCategory : "";

      case originFields.fireCauseSpecificDetailID:
        return value !== null ? fireCauseConfig.SpecificDetailFireCauses.find(cause => cause.SpecificDetailID === value).SpecificDetail : "";   

      default:
        return '';
    }
  }

  handleSuccessSnackRequestClose = () => {
    this.setState({
      firstValidationMessage: "",
    });
  };

  generateTableRows = () => {

    const nonMoveableFields = ["CreatedOnDateTime", "UniqueFireIdentifier", "CreatedBySystem", "FORID", "FireOccurenceRecordID","POODispatchCenterID", "ADSPermissionState", "DiscoveryAcres", "IsFireCodeRequested", "ModifiedBySystem", "ModifiedOnDateTime", "StatusID"];
    const fieldInfos = this.props.appConfig.fieldInfos;
    var tableRows = [];

    for (var i = 0; i < this.props.spliceModel.DifferentFields.length; i++) {
      const fieldName = this.props.spliceModel.DifferentFields[i];

      let isDoubleDate = originFields.dateFieldsWithTypeDouble.includes(fieldName);
      let currFieldInfo = fieldInfos.filter(i => i.name === fieldName);
      const isNonDoubleDate = (currFieldInfo && currFieldInfo.length > 0 && currFieldInfo[0].type === "date");

      const primaryFieldVal = this.props.spliceModel.PrimaryFOR[fieldName];
      const secondaryFieldVal = this.props.spliceModel.SecondaryFOR[fieldName];

      const primaryRadioChecked = primaryFieldVal === this.state.savedSpliceRecord[fieldName];
      const secondaryRadioChecked = secondaryFieldVal === this.state.savedSpliceRecord[fieldName];

      let primaryValue = (isDoubleDate || isNonDoubleDate) ? (primaryFieldVal ? moment(primaryFieldVal).format(this.props.appConfig.timeDateFormat) : "––") : primaryFieldVal;
      let secondaryValue = (isDoubleDate || isNonDoubleDate) ? (secondaryFieldVal ? moment(secondaryFieldVal).format(this.props.appConfig.timeDateFormat) : "––") : secondaryFieldVal;

      const primaryDisplayValue = (fireCauseIdFields.includes(fieldName)) ? this.getFireCauseDisplayValue(primaryFieldVal, fieldName) : null;
      const secondaryDisplayValue =  (fireCauseIdFields.includes(fieldName)) ? this.getFireCauseDisplayValue(secondaryFieldVal, fieldName) : null;
      
      tableRows.push(
        <TableRow key={i} style={{ padding: '8px' }}>
          <TableCell component="th" scope="row" style={this.getLabelStyle()}>{this.getLabelName(fieldName)}</TableCell>
          <TableCell align="left" style={this.getDataStyle(fieldName, primaryRadioChecked)}>
            <Radio value={primaryFieldVal} id={"radio_" + fieldName + "_left"}
              checked={primaryRadioChecked}
              disabled={!this.state.primarySet ||  nonMoveableFields.includes(fieldName) }
              onChange={(event, value) => {
                this.onSpliceChange(fieldName, primaryFieldVal, this.props.spliceModel.PrimaryFOR.FORID);
              }
              }
            />{primaryDisplayValue !== null ? primaryDisplayValue : primaryValue}
          </TableCell>
          <TableCell align="left" style={this.getDataStyle(fieldName, secondaryRadioChecked)}>
            <Radio value={secondaryFieldVal} id={"radio_" + fieldName + "_right"}
              checked={secondaryRadioChecked}
              disabled={!this.state.primarySet || nonMoveableFields.includes(fieldName)}
              onChange={(event, value) => {
                this.onSpliceChange(fieldName, secondaryFieldVal, this.props.spliceModel.SecondaryFOR.FORID);
              }
              } />{secondaryDisplayValue !== null ? secondaryDisplayValue : secondaryValue}
          </TableCell>
        </TableRow>
      )
    }
    return tableRows;
  }
  render() {

    if (!this.props.spliceModel || !this.props.spliceModel.DifferentFields || !this.props.spliceModel.DifferentFields.length > 0) {
      return '';
    }

    return (
      <Dialog
        title="Splice Fire Occurence Records"
        modal={true}
        titleStyle={styles.errorDialogTitle}
        open={this.props.open}
        fullScreen
        autoScrollBodyContent={true}>
        <Paper elevation={3}>
          <Table key={this.props.savedSpliceRecord}>
            <TableBody>
              <TableRow>
                <TableCell style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                  Incident Name
                </TableCell>
                <TableCell align="left" style={this.getHeaderStyle(this.props.spliceModel.PrimaryFOR.FORID)}>{this.props.spliceModel.PrimaryFOR.IncidentName}   {this.showChip(this.props.spliceModel.PrimaryFOR.FORID)}</TableCell>
                <TableCell align="left" style={this.getHeaderStyle(this.props.spliceModel.SecondaryFOR.FORID)}>{this.props.spliceModel.SecondaryFOR.IncidentName}   {this.showChip(this.props.spliceModel.SecondaryFOR.FORID)}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                  FOR ID
                </TableCell>
                <TableCell align="left" style={this.getHeaderStyle(this.props.spliceModel.PrimaryFOR.FORID)}>{this.props.spliceModel.PrimaryFOR.FORID}</TableCell>
                <TableCell align="left" style={this.getHeaderStyle(this.props.spliceModel.SecondaryFOR.FORID)}>{this.props.spliceModel.SecondaryFOR.FORID}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                </TableCell>
                <TableCell align="left" style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                  <Button onClick={() => this.makePrimary(this.props.spliceModel.PrimaryFOR.FORID)} disabled={(this.state.primaryFORID !== null && this.state.primaryFORID === this.props.spliceModel.PrimaryFOR.FORID)} variant="contained" color="primary">
                    Make Primary
                  </Button>
                </TableCell>
                <TableCell align="left" style={{ textAlign: 'left', fontSize: '0.8em', padding: '8px', fontWeight: 'bold' }}>
                  <Button onClick={() => this.makePrimary(this.props.spliceModel.SecondaryFOR.FORID)} disabled={(this.state.primaryFORID !== null && this.state.primaryFORID === this.props.spliceModel.SecondaryFOR.FORID)} variant="contained" color="primary">
                    Make Primary
                  </Button>
                </TableCell>
              </TableRow>

              {this.generateTableRows()}
            </TableBody>
          </Table>
          <DialogActions>
            <Button onClick={this.props.onCloseSpliceDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={() => this.props.onSpliceRecords(this.state.savedSpliceRecord, this.state.attributesFromLosingFODR)} disabled={!this.state.canSaveSplice} color="primary">
              Splice Occurence Records
            </Button>
          </DialogActions>
          <Snackbar
            open={Boolean(this.state.firstValidationMessage)}
            message={this.state.firstValidationMessage}
            autoHideDuration={5000}
            onClose={this.handleSuccessSnackRequestClose}
        />
        </Paper>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config
})

export default connect(mapStateToProps)(SpliceDialog)
